import { useState, useEffect } from "react";
import SchoolHeader from "../header";
import SchoolSidebar from "../sidebar";
import { Link, useSearchParams } from "react-router-dom";
import QuizServices from "../../../services/QuizServices";
import TeacherServices from "../../../services/TeacherServices";
import "./index.css";

const ViewAction = () => {
  const [searchParams] = useSearchParams();

  const [courseVidoes, setCourseVideos] = useState([]);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [currentGroupIndex, setCurrentGroupIndex] = useState(0);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await TeacherServices.getVideosWithQuiz(
          searchParams.get("teacher_id")
        );
        if (response && response.videos) {
          setCourseVideos(response.videos);
        }
      } catch (error) {}
    };

    const fetchTeacherData = async () => {
      try {
        const data = await QuizServices.getProcess(
          searchParams.get("teacher_id")
        );
        setCurrentVideoIndex(data.currentVideoIndex);
        setCurrentGroupIndex(data.currentGroupIndex);
      } catch (error) {}
    };

    fetchVideos();
    fetchTeacherData();
  }, []);

  const completedBefore = courseVidoes
    .filter((_, index) => index < currentVideoIndex)
    .flatMap((group) =>
      group.quizzes.map((quiz) => ({
        ...quiz,
        status: "Completed",
      }))
    );

  const completedCurrent = courseVidoes.flatMap((group, groupIndex) =>
    groupIndex === currentVideoIndex
      ? group.quizzes
          .filter((_, quizIndex) => quizIndex < currentGroupIndex)
          .map((quiz) => ({
            ...quiz,
            status: "Completed",
          }))
      : []
  );

  const notCompleted = courseVidoes.flatMap((group, groupIndex) =>
    groupIndex === currentVideoIndex
      ? group.quizzes
          .filter((_, quizIndex) => quizIndex >= currentGroupIndex)
          .map((quiz) => ({
            ...quiz,
            status: "Not Completed",
          }))
      : []
  );

  const notCompletedAfter = courseVidoes
    .filter((_, index) => index > currentVideoIndex)
    .flatMap((group) =>
      group.quizzes.map((quiz) => ({
        ...quiz,
        status: "Not Completed",
      }))
    );

  const allRows = [
    ...completedBefore,
    ...completedCurrent,
    ...notCompleted,
    ...notCompletedAfter,
  ];

  return (
    <div className="main-wrapper">
      <SchoolHeader activeMenu={"Dashboard"} />

      <div className="breadcrumb-bar breadcrumb-bar-info">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="breadcrumb-list">
                <h2 className="breadcrumb-title">
                  {searchParams.get("name")}&apos;s Action Status
                </h2>
                <nav aria-label="breadcrumb" className="page-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/school-dashboard">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Dashboard
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="row">
            <SchoolSidebar />
            <div className="col-xl-9 col-lg-9">
              <div className="table-responsive custom-table">
                <table
                  id="orderHistoryTable"
                  className="table table-nowrap mb-0"
                >
                  <thead>
                    <tr>
                      <th>Video Order</th>
                      <th>Video Course Name</th>
                      <th>Status</th>
                      <th>Take Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allRows.map((quiz, index) => (
                      <tr key={quiz._id}>
                        <td>{index + 1}</td>
                        <td>{quiz.videoName}</td>
                        <td
                          style={{
                            color:
                              quiz.status === "Completed" ? "green" : "red",
                          }}
                        >
                          {quiz.status}
                        </td>
                        <td>
                          {quiz.status === "Completed" ? (
                            <Link
                              to={`/teachertest/mcq-test?teacher_id=${searchParams.get(
                                "teacher_id"
                              )}&video_id=${index}`}
                            >
                              Retake Action
                            </Link>
                          ) : (
                            <Link
                              to={`/teachertest/mcq-test?teacher_id=${searchParams.get(
                                "teacher_id"
                              )}`}
                            >
                              Take Action
                            </Link>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAction;
